import React, { FC } from "react";
import useStyles from "./styles";

export const ActiveScanner: FC = () => {
  const classes = useStyles();
  return (
    <div data-testid="active-scanner-wrapper" className={classes.container}>
      <div data-testid="active-scanner-top-left" className={classes.activeScannerTopLeft} />
      <div data-testid="active-scanner-top-right" className={classes.activeScannerTopRight} />
      <div data-testid="active-scanner-bottom-left" className={classes.activeScannerBottomLeft} />
      <div data-testid="active-scanner-bottom-right" className={classes.activeScannerBottomRight} />
    </div>
  );
};
